// extracted by mini-css-extract-plugin
export default {"icon":"G9b34aa"};